import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@22.19.7_@vue+compiler-sfc@3.5.27_cac@6.7._e567e5e2b2142444d629666a5f614a9e/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import navigation_45global from "/opt/buildhome/repo/middleware/navigation.global.ts";
import redirects_45global from "/opt/buildhome/repo/middleware/redirects.global.ts";
import trailing_45slash_45global from "/opt/buildhome/repo/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@22.19.7_@vue+compiler-sfc@3.5.27_cac@6.7._e567e5e2b2142444d629666a5f614a9e/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  navigation_45global,
  redirects_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts"),
  authenticated: () => import("/opt/buildhome/repo/middleware/authenticated.ts"),
  "has-active-membership": () => import("/opt/buildhome/repo/middleware/has-active-membership.ts"),
  "premium-market-guard": () => import("/opt/buildhome/repo/middleware/premium-market-guard.ts"),
  "redirect-tab": () => import("/opt/buildhome/repo/middleware/redirect-tab.ts"),
  "refresh-live-chat": () => import("/opt/buildhome/repo/middleware/refresh-live-chat.ts")
}